import i18n from 'i18next'; import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box } from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';

const CreateActivityAreaDialog = (props) => {
  const { open, onClose, initialValue, handleCreate } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >

      <Formik
        initialValues={
        {
          name: initialValue
        }
        }
        validationSchema={yup.object().shape({
          name: yup.string().required('zorunlu')
        })}
        onSubmit={handleCreate}
      >

        {
        ({ values, errors, touched, handleSubmit, handleChange }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle>{i18n.t('CreateActivityAreaDialog.yeni_faaliyet_alan\u0131')}</DialogTitle>
            <DialogContent>
              <Box sx={{
                m: 1,
                width: 240
              }}
              >

                <TextField
                  autoFocus
                  margin="dense"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  label={i18n.t('CreateActivityAreaDialog.faaliyet_alan\u0131_ad\u0131')}
                  type="text"
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />

              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={onClose}
                color="primary"
              >
                {i18n.t('CreateActivityAreaDialog.i_ptal')}

              </Button>
              <Button
                type="submit"
                color="primary"
                variant="contained"
              >
                {i18n.t('CreateActivityAreaDialog.ekle')}

              </Button>
            </DialogActions>
          </form>
        )
}
      </Formik>
    </Dialog>
  );
};

export default CreateActivityAreaDialog;

CreateActivityAreaDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  initialValue: PropTypes.string,
  handleCreate: PropTypes.func
};
